import React, {useContext} from 'react';
import {
  VictoryAxis,
  VictoryChart,
  VictoryClipContainer,
  VictoryLine,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from 'victory';
import {PathDesignContext} from './path-design-context';
import {
  chartPadding,
  chartTheme,
  getColorOnScale,
  getPathColorOnScale,
} from 'src/components/victory/chartTheme';
import {formatShortMonthAndYear} from 'src/utils/formatters';
import Legend from 'src/components/victory/legend/Legend';
import {Point} from 'src/types/util';
import {formatNumericAxisLabels} from 'src/components/victory/utils';

export interface LineGraphProps<P = Point<Date, number>> {
  data: P[][];
  labels?: (opts: {datum: P}) => string;
  legendLabels?: string[];
}

export default function LineGraph(props: LineGraphProps) {
  const path = useContext(PathDesignContext);

  return (
    <>
      <Legend labels={props.legendLabels} />
      <VictoryChart
        scale={{x: 'time'}}
        theme={chartTheme(path.enabled)}
        padding={chartPadding}
        domainPadding={{x: 20, y: 10}}
        minDomain={{y: 0}}
        containerComponent={
          <VictoryVoronoiContainer
            labels={props.labels}
            labelComponent={<VictoryTooltip constrainToVisibleArea />}
          />
        }
      >
        <VictoryAxis tickFormat={formatShortMonthAndYear} />
        <VictoryAxis dependentAxis tickFormat={formatNumericAxisLabels} />
        {props.data.map((data, index) => (
          <VictoryLine
            data={data}
            key={index}
            groupComponent={<VictoryClipContainer clipPadding={{bottom: 4}} />}
            style={{
              data: {
                stroke: path.enabled ? getPathColorOnScale(index) : getColorOnScale(index),
              },
            }}
          />
        ))}
      </VictoryChart>
    </>
  );
}
